import { render, staticRenderFns } from "./FinancialPlan.vue?vue&type=template&id=06844073&scoped=true&"
import script from "./FinancialPlan.vue?vue&type=script&lang=js&"
export * from "./FinancialPlan.vue?vue&type=script&lang=js&"
import style0 from "./FinancialPlan.vue?vue&type=style&index=0&id=06844073&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06844073",
  null
  
)

export default component.exports